import baseAPI from '@/api/base';
import {
  EditZmanim,
  GetZmanim,
  RegisterZmanim,
} from '@/dtos/zmanim.dto';
import {
  DELETE_ZMANIM_URL,
  EDIT_ZMANIM_URL,
  GET_ZMANIM_URL,
  REGISTER_ZMANIM_URL,
  TOGGLE_ZMANIM_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class Zmanim {
  static getZmanims = async (
    getZmanim: GetZmanim
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_ZMANIM_URL, {
      params: getZmanim,
    });
    console.log('response', response);
    return response;
  };

  static registerZmanim = async (
    registerZmanim: RegisterZmanim
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(
      REGISTER_ZMANIM_URL,
      {
        ...registerZmanim,
      }
    );
    console.log('response', response);
    return response;
  };

  static editZmanim = async (
    editZmanim: EditZmanim
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(
      EDIT_ZMANIM_URL,
      {
        ...editZmanim,
      }
    );
    return response;
  };

  static toggleZmanimIsActive = async (
    editZmanim: EditZmanim
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_ZMANIM_IS_ACTIVE_URL,
      {
        ...editZmanim,
      }
    );
    return response;
  };

  static deleteZmanim = async (
    id: string
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_ZMANIM_URL}/${id}`
    );
    return response;
  };
}

export default Zmanim;
